import React, { useState } from 'react';
import './Home.css';
import { tokenService } from '../../services/auth/tokenService';
//components
import TabComponent from '../../components/TabComponent/TabComponent';
//views
import UsersCharts from './UsersCharts/UsersCharts';
import RankingCharts from './RankingCharts/RankingCharts';
import ServicesCharts from './ServicesCharts/ServicesCharts';
import PackagesCharts from './PackagesCharts/PackagesCharts';
import CategoriesCharts from './CategoriesCharts/CategoriesCharts';
import SupportCharts from './SupportCharts/SupportCharts';
import BucksCharts from './BucksCharts/BucksCharts';
import GroupsCharts from './GroupsCharts/GroupsCharts';

const Home = () => {
  console.log("*************************************")
  console.log(tokenService.getAccessToken());
  console.log("*************************************")
  const [activeTab, setActiveTab] = useState('users');
  const tabs = [
    { id: 'users', label: 'Users' },
    { id: 'ranks', label: 'Rankings' },
    { id: 'services', label: 'Services' },
    { id: 'packages', label: 'Packages' },
    { id: 'categories', label: 'Categories' },
    { id: 'support', label: 'Support' },
    { id: 'barter-bucks', label: 'Barter Bucks' },
    { id: 'groups', label: 'Groups' },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'users':
        return <UsersCharts />
      case 'ranks':
        return <RankingCharts />
      case 'services':
        return <ServicesCharts />
      case 'packages':
        return <PackagesCharts />
      case 'categories':
        return <CategoriesCharts />
      case 'support':
        return <SupportCharts />
      case 'barter-bucks':
        return <BucksCharts />
      case 'groups':
        return <GroupsCharts/>
      default:
        return null;
    }
  };



  return (
    <div className="dashboard-home">
      <TabComponent
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      >
        {renderTabContent()}
      </TabComponent>
    </div>
  );
};

export default Home;
